import { useEffect } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectGlobalLoading } from '../../../store/ui/uiSelectors'
import { logTiming } from '@/utils/timing'

const GlobalLoadingManager = () => {
    const globalLoading = useAppSelector(selectGlobalLoading)

    useEffect(() => {
        logTiming(`[loader] globalLoading=${globalLoading}`)
        if (!globalLoading) {
            document.body.classList.add('--loaded')
            logTiming('[loader] body.--loaded added (loader hidden)')
        } else {
            document.body.classList.remove('--loaded')
        }
    }, [globalLoading])

    return null
}

export default GlobalLoadingManager
